import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension'

import rootReducer from './reducers'

const composeEnhancers = composeWithDevTools({
  trace: true,
})

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))

export default store
